<script lang="ts">
    import TopicCard from "../card/TopicCard.svelte";
    import { ClusterStore, ClusterType } from "$/stores/ClusterStore";
    import { redirect } from "@roxi/routify";
    import { clickAction } from "$/utils/clickAction";

    export let topicGroups;

    const createNewTopic = async () => {
        let topic = await ClusterStore.createTopic(
            { name: "Untitled" },
            {
                id: null,
                clusterType: ClusterType.TENANT_DEFAULT,
            },
        );
        $redirect(`/${topic.id}`);
    };
</script>

<div class="topic-group-wrapper">
    {#each topicGroups as topicGroup, index (index)}
        <div class="topic-group">
            <div class="topic-group-title">
                <span>{@html topicGroup.title}</span>
            </div>

            <div class="topic-group-description">
                <span>{@html topicGroup.description}</span>
            </div>

            {#each topicGroup.groups as group, index (index)}
                {#if group.title.length}
                    <div class="topic-group-snippet-title">
                        <span>{@html group.title}</span>
                    </div>
                {/if}

                {#if index === 0 && !group.topics.length}
                    <div class="add-new-topic" use:clickAction={createNewTopic}>
                        <div class="add-new-topic__icon">
                            <svg
                                class="h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M12 4.5v15m7.5-7.5h-15"
                                />
                            </svg>
                        </div>
                        <div class="add-new-topic__text">
                            Create a new topic
                        </div>
                    </div>
                {:else}
                    <div class="topic-cards-wrapper">
                        {#each group.topics as topic, index (topic.id)}
                            <div class="card-wrapper">
                                <TopicCard {topic} />
                            </div>
                        {/each}
                    </div>
                {/if}
            {/each}
        </div>
    {/each}
</div>

<style>
    .topic-group-wrapper {
        @apply flex w-full flex-col overflow-y-auto overflow-x-hidden;
    }

    .topic-group-title {
        @apply w-full px-5 pt-5 text-xl font-semibold;
    }

    .topic-group-description {
        @apply w-full px-5 text-sm;
    }

    .topic-group-snippet-title {
        @apply -mb-2 w-full px-5 pt-5 text-lg outline-none;
    }

    .topic-cards-wrapper {
        @apply mx-5 flex flex-grow flex-col items-center gap-5 overflow-x-hidden py-5 md:flex-row md:flex-wrap md:items-start;
    }

    .card-wrapper {
        @apply z-20 w-full md:relative md:h-full md:w-60 md:flex-[0_0_auto] md:overflow-y-auto;
    }

    .no-recent-topic-img {
        @apply hidden max-h-32 md:block md:pl-5 lg:max-h-36;
    }

    .add-new-topic {
        @apply m-5 flex h-24 w-48 cursor-pointer flex-col items-center justify-center overflow-clip rounded-xl border border-gray-200 transition-all hover:scale-105 hover:shadow-md;
    }

    .add-new-topic__icon {
        @apply flex h-full w-full items-center justify-center bg-gray-100 text-gray-300;
    }

    .add-new-topic__icon svg {
        @apply h-10 w-10;
    }

    .add-new-topic__text {
        @apply p-2 text-xs;
    }
</style>
